<template>
  <div>
    <h1>Main Screen</h1>
    <nav>
      <!-- <button class="button-paper" @click="navigateToChangePassword">Change Password</button> -->
      <button class="button-paper" @click="logout">Logout</button>
      <button class="button-paper" @click="fetchTasks">Refresh</button>
    </nav>
    <div v-if="alertMessage" class="alert alert-danger" role="alert">
       {{ alertMessage }}
    </div>
    <table>
      <thead>
        <tr>
          <th>Task</th>
          <th>Status</th>
          <th class="action">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="task in tasks" :key="task.id">
          <td>{{ task.name }}</td>
          <td class="status">{{ task.status }}</td>
          <td class="action">
            <button class="button-paper" v-show="task.status!='Stopped'" @click="stopTask(task.id)">Stop</button>
            <button class="button-paper" v-show="task.status!='Running'" @click="restartTask(task.id)">Restart</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
// https://tochoromero.github.io/vuejs-smart-table/

//import UserService from "../services/user.service";
import { computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

export default {
  name: 'MainPage',
  setup() {
    const store = useStore()
    const router = useRouter()

    // Computed properties - convert from computed object with mapState
    const currentUser = computed(() => store.state.auth.username)
    const tasks = computed(() => store.state.task.tasks)
    const alertMessage = computed(() => store.state.task.alertMessage)

    // Methods - convert from methods object with mapActions
    const fetchTasks = () => {
      return store.dispatch('task/fetchTasks')
    }

    const setTaskStatus = (payload) => {
      return store.dispatch('task/setTaskStatus', payload)
    }

    const restartTask = async (taskID) => {
      await setTaskStatus({ taskID, status: 'Running' })
      await fetchTasks()
    }

    const stopTask = async (taskID) => {
      await setTaskStatus({ taskID, status: 'Stopped' })
      await fetchTasks()
    }

    const logout = async () => {
      await store.dispatch('auth/logout')
      router.push({name: 'login'})
    }

    // Lifecycle hooks - convert created() and mounted()
    onMounted(() => {
      // Fetch tasks from backend and set to this.tasks
      fetchTasks()
    })

    return {
      currentUser,
      tasks,
      alertMessage,
      fetchTasks,
      restartTask,
      stopTask,
      logout
    }
  }
}
</script>

<style scoped>
 input {
  margin: 0 10px 0;
  padding: .3rem;
 }

table {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  border-collapse: collapse;
  border: 2px solid rgb(140 140 140);
}
thead, tfoot {background-color: darkgray; }
th { height: 2rem; }
th, td {
  border: 1px solid rgb(160 160 160);
  padding: 8px 10px;
}

tbody > tr:nth-of-type(even) {
  background-color: lavenderblush;
}

.action {
    width: auto;
}

.status {
    text-align: center;
    width: 100px;
}
td{
    white-space: normal;
/*	white-space: nowrap;*/
/*	text-overflow: ellipsis;*/
}

</style>
